import store from '../../src/store'

export default class DealerHelper {
    static getDealer(dealerid) {
        return store.state.dealers.find(dealer => {
            return dealer.dealerid === dealerid;
        });
    }

    static getDealerChildren(dealerid, includeDealer = false) {
        if (!this.dealersChildren) {
            this.dealersChildren = {};
        }
        if (this.dealersChildren.hasOwnProperty(dealerid.toLowerCase())) {
            return this.dealersChildren[dealerid.toLowerCase()];
        }
        let result = [];

        if (includeDealer) {
            result.push(dealerid);
        }

        if (!store.state.dealers) {
            return result;
        }

        const children = store.state.dealers.filter(dealer => dealer.parent.toLowerCase() === dealerid.toLowerCase());
        for (let childDealer of children) {
            result.push(childDealer.dealerid.toLowerCase());
            result = result.concat(this.getDealerChildren(childDealer.dealerid.toLowerCase()));
        }

        this.dealersChildren[dealerid.toLowerCase()] = result;

        return result;
    }

    static getDealerTree(dealerid) {
        let result = Object.assign({}, this.getDealer(dealerid));

        this.buildChildrenTree(result, dealerid);

        return result;
    }

    static buildChildrenTree(root, dealerid) {
        root.children = [];

        const children = store.state.dealers.filter(dealer => dealer.parent.toLowerCase() === dealerid.toLowerCase());

        for (let child of children) {
            child.dealerid = child.dealerid.toLowerCase()
            this.buildChildrenTree(child, child.dealerid);
            root.children.push(child);
        }
    }
}
